import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.colors.primary.contrastWhite,
        boxShadow: theme.shadows[2],
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        '& > *': Object.assign(Object.assign({}, theme.typography.body2), { color: theme.colors.text[900] }),
    },
    arrow: {
        color: theme.colors.primary.contrastWhite,
    },
}));
//# sourceMappingURL=Tooltip.styles.js.map